import { Pipe, PipeTransform } from '@angular/core';
import { Form, Frequency } from './interface';

const BaseTranslationKey = 'GALAXY.FREQUENCY.';

const ShortFrequencyTranslationKey = BaseTranslationKey + 'SHORT.';
const LongFrequencyTranslationKey = BaseTranslationKey + 'LONG.';
const VerboseFrequencyTranslationKey = BaseTranslationKey + 'VERBOSE.';

const ShortFreqString: Record<string, string> = {
  [Frequency.MONTHLY]: ShortFrequencyTranslationKey + 'MONTHLY',
  [Frequency.YEARLY]: ShortFrequencyTranslationKey + 'YEARLY',
  [Frequency.WEEKLY]: ShortFrequencyTranslationKey + 'WEEKLY',
  [Frequency.DAILY]: ShortFrequencyTranslationKey + 'DAILY',
  [Frequency.QUARTERLY]: ShortFrequencyTranslationKey + 'QUARTERLY',
  [Frequency.BI_WEEKLY]: ShortFrequencyTranslationKey + 'BI_WEEKLY',
};

const LongFreqString: Record<string, string> = {
  [Frequency.MONTHLY]: LongFrequencyTranslationKey + 'MONTHLY',
  [Frequency.YEARLY]: LongFrequencyTranslationKey + 'YEARLY',
  [Frequency.WEEKLY]: LongFrequencyTranslationKey + 'WEEKLY',
  [Frequency.DAILY]: LongFrequencyTranslationKey + 'DAILY',
  [Frequency.QUARTERLY]: LongFrequencyTranslationKey + 'QUARTERLY',
  [Frequency.BI_WEEKLY]: LongFrequencyTranslationKey + 'BI_WEEKLY',
};

const VerboseFreqString: Record<string, string> = {
  [Frequency.MONTHLY]: VerboseFrequencyTranslationKey + 'MONTHLY',
  [Frequency.YEARLY]: VerboseFrequencyTranslationKey + 'YEARLY',
  [Frequency.WEEKLY]: VerboseFrequencyTranslationKey + 'WEEKLY',
  [Frequency.DAILY]: VerboseFrequencyTranslationKey + 'DAILY',
  [Frequency.QUARTERLY]: VerboseFrequencyTranslationKey + 'QUARTERLY',
  [Frequency.BI_WEEKLY]: VerboseFrequencyTranslationKey + 'BI_WEEKLY',
};

@Pipe({
  name: 'glxyFrequency',
})
export class GalaxyFrequencyPipe implements PipeTransform {
  transform(frequency: Frequency = Frequency.ONE_TIME, form: Form | 'short' | 'long' | 'verbose' = Form.SHORT): string {
    let freq = '';
    if (form.toLowerCase() === 'long') {
      freq = this.getLongFrequency(frequency);
    } else if (form.toLowerCase() === 'verbose') {
      freq = this.getVerboseFrequency(frequency);
    } else {
      freq = this.getShortFrequency(frequency);
    }

    if (freq !== '') {
      return `${freq}`;
    }
    return '';
  }

  private getShortFrequency(frequency: Frequency): string {
    return ShortFreqString[frequency] || '';
  }

  private getLongFrequency(frequency: Frequency): string {
    return LongFreqString[frequency] || '';
  }

  private getVerboseFrequency(frequency: Frequency): string {
    return VerboseFreqString[frequency] || '';
  }
}
